import { DYNATRACE_PAGES } from '@/core/constants/dynatraceCatalog';

export type DynatracePageKey = keyof typeof DYNATRACE_PAGES;

/** Resolve catalogue `p_screen` for a page key (web + native). */
export function dtScreen(pageKey: DynatracePageKey): string {
    return DYNATRACE_PAGES[pageKey].screen;
}

/** Common `p_screen` values — prefer `dtScreen('welcome')` for new code. */
export const DT_SCREEN = {
    LANDING_PAGE: DYNATRACE_PAGES.landingPage.screen,
    LANDING_PAGE_SPACE: DYNATRACE_PAGES.landingPageSpace.screen,
    WELCOME: DYNATRACE_PAGES.welcome.screen,
    LOGIN: DYNATRACE_PAGES.login.screen,
    GUEST_HOME: DYNATRACE_PAGES.guestHome.screen,
    GUEST: DYNATRACE_PAGES.guest.screen,
    GUEST_UNIT: DYNATRACE_PAGES.guestUnit.screen,
    ALMETLAA_AUTH: DYNATRACE_PAGES.almetlaaAuth.screen,
    ALMETLAA_CATALOGUE: DYNATRACE_PAGES.almetlaaCatalogue.screen,
    ALMETLAA_PROJECT: DYNATRACE_PAGES.almetlaaProject.screen,
    ALMETLAA_UNIT: DYNATRACE_PAGES.almetlaaUnit.screen,
    ALMETLAA_RESERVE: DYNATRACE_PAGES.almetlaaReserve.screen,
    ALMETLAA_APPOINTMENT: DYNATRACE_PAGES.almetlaaAppointment.screen,
    ALMETLAA_TOP_UP: DYNATRACE_PAGES.almetlaaTopUp.screen,
    ALMETLAA_PROFILE: DYNATRACE_PAGES.almetlaaProfile.screen,
    ALMETLAA_SUPPORT: DYNATRACE_PAGES.almetlaaSupport.screen,
    ALMETLAA_FAQ: DYNATRACE_PAGES.almetlaaFaq.screen,
    HOME: DYNATRACE_PAGES.home.screen,
    PROPERTIES: DYNATRACE_PAGES.properties.screen,
    PAYMENTS: DYNATRACE_PAGES.payments.screen,
    PROPERTY_PAYMENTS: DYNATRACE_PAGES.propertyPayments.screen,
    PAYMENT_FILTER: DYNATRACE_PAGES.paymentFilter.screen,
    PAYMENT_SUMMARY: DYNATRACE_PAGES.paymentSummary.screen,
    PAYMENT_CHECKOUT: DYNATRACE_PAGES.paymentCheckout.screen,
    PAYMENT_DETAILS: DYNATRACE_PAGES.paymentDetails.screen,
    PAYMENT_PROOF: DYNATRACE_PAGES.paymentProof.screen,
    BANK_TRANSFER: DYNATRACE_PAGES.bankTransfer.screen,
    PAYMENT_RESULT: DYNATRACE_PAGES.paymentResult.screen,
    PROFILE: DYNATRACE_PAGES.profile.screen,
    PERSONAL_DETAILS: DYNATRACE_PAGES.personalDetails.screen,
    LOAN_DETAILS: DYNATRACE_PAGES.loanDetails.screen,
    ID_PROOF: DYNATRACE_PAGES.idProof.screen,
    PRIVACY_SECURITY: DYNATRACE_PAGES.privacySecurity.screen,
    LEGAL: DYNATRACE_PAGES.legal.screen,
    FAQ: DYNATRACE_PAGES.faq.screen,
    LOGOUT_SUCCESS: DYNATRACE_PAGES.logoutSuccess.screen,
    SERVICE_REQUEST: DYNATRACE_PAGES.serviceRequest.screen,
    SERVICE_REQUEST_CREATE: DYNATRACE_PAGES.serviceRequestCreate.screen,
    SERVICE_REQUEST_DETAIL: DYNATRACE_PAGES.serviceRequestDetail.screen,
    SERVICE_REQUEST_SUCCESS: DYNATRACE_PAGES.serviceRequestSuccess.screen,
    FORGOT_PASSWORD: DYNATRACE_PAGES.forgotPassword.screen,
    PASSWORD_SENT: DYNATRACE_PAGES.passwordSent.screen,
    SET_NEW_PASSWORD: DYNATRACE_PAGES.setNewPassword.screen,
    CHANGE_PASSWORD: DYNATRACE_PAGES.changePassword.screen,
    REGISTRATION: DYNATRACE_PAGES.registration.screen,
    REGISTRATION_SUCCESS: DYNATRACE_PAGES.registrationSuccess.screen,
    DOCUMENT_SCANNER: DYNATRACE_PAGES.documentScanner.screen,
    DOCUMENT_REVIEW: DYNATRACE_PAGES.documentReview.screen,
    DOCUMENT_VIEWER: DYNATRACE_PAGES.documentViewer.screen,
    OTP_INLINE: DYNATRACE_PAGES.otpInline.screen,
    PASSCODE: DYNATRACE_PAGES.passcode.screen,
    PASSCODE_LOGIN: DYNATRACE_PAGES.passcodeLogin.screen,
    UAE_PASS: DYNATRACE_PAGES.uaePass.screen,
    UAE_PASS_DETAILS: DYNATRACE_PAGES.uaePassDetails.screen,
} as const;
